import { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link, useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faPlus } from "@fortawesome/free-solid-svg-icons";
import Dropdown from "react-bootstrap/Dropdown";
import ObjectivesList from "../Components/ObjectivesList";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import { useTranslation } from "react-i18next";
import "./PersonObjectives.css";

function PersonObjectives() {
  const [isLoading, setIsLoading] = useState(true);
  const [openObjectives, setOpenObjectives] = useState([]);
  const [closedObjectives, setClosedObjectives] = useState([]);
  const [user, setUser] = useState({});

  const { state } = useContext(AuthContext);

  let { pid } = useParams();

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/objectives/organization/${pid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setOpenObjectives(response.data.openObjectives);
      setClosedObjectives(response.data.closedObjectives);
      setUser(response.data.user);
      setIsLoading(false);
    }
    fetch();
  }, [state.organization, state.token, pid]);

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row className="align-items-center">
          <Col lg={11} className="person-objectives-header">
            <h2>
              {t("Objetivos.MisObjetivos.Titulo")} - {user.firstName}{" "}
              {user.lastName}
            </h2>
          </Col>
          <Col lg={1} className="right person-objectives-content">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                <FontAwesomeIcon icon={faList} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item as={Link} to={`/objectives/new`}>
                  <FontAwesomeIcon icon={faPlus} />{" "}
                  {t("Objetivos.MisObjetivos.NuevoObjetivo")}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
        <Row className="align-items-center">
          {openObjectives.length === 0 ? (
            <Col className="empty-objectives center">
              <h5>{t("Objetivos.SinObjetivos")}</h5>
            </Col>
          ) : (
            <ObjectivesList
              objectives={openObjectives}
              language={state.language}
            />
          )}
        </Row>
      </Container>
    );
  }
}

export default PersonObjectives;
